import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  state: {
    abas: {
      dadosCadastrais: {
        nomeAba: "Dados Cadastrais",
        temError: true
      },
      infraestrutura: {
        nomeAba: "Infraestrutura e Tecnologia",
        temError: false
      },
      diretorTecnico: {
        nomeAba: "Dados Complementares do Diretor Técnico",
        temError: true
      },
      servicos: {
        nomeAba: "Serviços",
        temError: false
      },
      transplantes: {
        nomeAba: "Transplantes",
        temError: false
      },
      atendimento: {
        nomeAba: "Atendimento e Intercâmbio",
        temError: false
      },
      servicosPrestados: {
        nomeAba: "Serviços Prestados",
        temError: false
      },
      especialidadesServicosPrestados: {
        nomeAba: "Especialidades e Serviços Prestados",
        temError: false
      },
      dadosUnidadeAps: {
        nomeAba: "Dados Unidade APS",
        temError: false
      }
    },
    mostrarErrors: false
  },
  mutations,
  actions,
  getters
};
